import { strVal } from "@paroi/data-formatters-lib";

export interface Relation {
  id: string;
  sourceTableId: string;
  targetTableId: string;
  sourceColumn: string;
  targetColumn: string;
  type: string; // e.g., "one_to_many", "many_to_one", "one_to_one", "many_to_many"
}

export interface RelationType {
  [relationName: string]: string;
}

export function formatToRelation(data: unknown): Relation {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    throw new Error("Invalid data");
  }
  const validData = data as Record<string, unknown>;
  return {
    id: strVal(validData.id),
    sourceTableId: strVal(validData.source_table_id),
    targetTableId: strVal(validData.target_table_id),
    sourceColumn: strVal(validData.source_column),
    targetColumn: strVal(validData.target_column),
    type: strVal(validData.type),
  };
}

export function formatToRelationType(data: unknown): RelationType | undefined {
  if (typeof data !== "object" || data === null) {
    throw new Error("Invalid data");
  }
  const validData = data as Record<string, unknown>;
  const formatedData = Object.entries(validData).reduce(
    (acc, [key, value]) => {
      acc[key] = strVal(value);
      return acc;
    },
    {} as Record<string, string>,
  );
  if (Object.keys(formatedData).length === 0) {
    return;
  }
  return {
    ...formatedData,
  };
}
